function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#F8FAFF",
  fillRule: "evenodd",
  stroke: "#DBDFE8",
  d: "M28.705 33.7l-1.438-11.627 7.998-8.562-11.503-2.226-5.671-10.252-5.671 10.252L.917 13.51l7.997 8.562L7.477 33.7l10.614-4.96 10.614 4.96z"
});

const SvgComponent = props => React.createElement("svg", _extends({
  width: 37,
  height: 35,
  viewBox: "0 0 37 35"
}, props), _ref);

export default __webpack_public_path__ + "static/media/star-grey.1010dd47.svg";
export { SvgComponent as ReactComponent };